"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseUpdatedEvent = exports.BaseEvent = exports.buildUpdatedEvent = exports.buildEvent = void 0;
const objectRecursion_1 = require("./objectRecursion");
const buildEvent = (item, senderId, eventId) => {
    return (0, objectRecursion_1.stripUndefined)({ item, kind: 'event', senderId, timestamp: new Date().toISOString(), eventId });
};
exports.buildEvent = buildEvent;
const buildUpdatedEvent = (before, after, senderId, eventId) => {
    return (0, objectRecursion_1.stripUndefined)({
        before,
        after,
        senderId,
        kind: 'updated-event',
        timestamp: new Date().toISOString(),
        eventId,
    });
};
exports.buildUpdatedEvent = buildUpdatedEvent;
class BaseEvent {
    payload;
    constructor(payload) {
        this.payload = payload;
    }
}
exports.BaseEvent = BaseEvent;
class BaseUpdatedEvent {
    payload;
    constructor(payload) {
        this.payload = payload;
    }
}
exports.BaseUpdatedEvent = BaseUpdatedEvent;
